(() => {
  if (customElements.get('dc-quantity-summary')) return;
  class QuantitySummary extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('product-info') || this.closest('section');
      this.config = JSON.parse(this.querySelector('script').textContent);
      this.output = this.querySelector('[role="status"]');
      this.refresh = this.refresh.bind(this);
      this.scope.addEventListener('input', this.refresh);
      this.scope.addEventListener('change', this.refresh);
      this.scope.addEventListener('click', this.refresh);
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.scope, {childList:true,subtree:true,attributes:true,attributeFilter:['value','min','step']});
      this.refresh();
    }
    disconnectedCallback() {
      this.scope.removeEventListener('input', this.refresh);
      this.scope.removeEventListener('change', this.refresh);
      this.scope.removeEventListener('click', this.refresh);
      this.observer.disconnect();
      cancelAnimationFrame(this.frame);
    }
    refresh() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const input = this.scope.querySelector('input[name="quantity"]');
        const variant = this.scope.querySelector('form[action*="/cart/add"] input[name="id"]');
        if (!input || !variant) return;
        const qty = Number(input.value);
        const pack = Number(this.config.variants[variant.value]);
        if (!Number.isInteger(qty) || qty < 1 || !Number.isInteger(pack) || pack < 1) {
          if (this.output.textContent) this.output.textContent = '';
          return;
        }
        const l = this.config.labels;
        const full = Math.floor(qty / pack);
        const extra = qty % pack;
        let text = this.config.bundle ? (qty === 1 ? l.one_set : qty + ' ' + l.sets) : qty + ' ' + (qty === 1 ? l.unit : l.units);
        if (pack > 1 && !this.config.bundle) {
          const parts = [];
          if (full) parts.push(full === 1 ? l.one_set : full + ' ' + l.sets);
          if (extra) parts.push(extra + ' ' + l.extra);
          text += ' (' + parts.join(' + ') + ')';
        }
        if (this.output.textContent !== text) this.output.textContent = text;
      });
    }
  }
  customElements.define('dc-quantity-summary', QuantitySummary);
})();

